// useHoveredCard.js
import { create } from 'zustand'

const useHoveredCard = create((set) => ({
  hoveredCard: null,
  setHoveredCard: (hoveredCard: any) => {
    set({ hoveredCard })
  },
}))

export default useHoveredCard
